import { IconProps } from './index';

const Mute: React.VFC<IconProps> = ({ title, titleId, ...props }) => {
    return (
        <svg
            width="22"
            height="23"
            viewBox="0 0 22 23"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-labelledby={titleId}
            {...props}
        >
            {title && <title id={titleId}>{title}</title>}
            <path
                d="M15.4246 17.839C14.3697 18.436 13.2044 18.8123 11.9996 18.945V23H9.99958V18.945C7.97071 18.7176 6.07936 17.8074 4.63575 16.3638C3.19215 14.9202 2.28199 13.0289 2.05458 11H4.06958C4.22548 12.0794 4.63137 13.1075 5.25489 14.0023C5.87842 14.8971 6.70235 15.6338 7.661 16.1539C8.61965 16.6739 9.68653 16.9628 10.7766 16.9975C11.8666 17.0323 12.9498 16.8119 13.9396 16.354L12.3886 14.804C11.6438 15.0194 10.8591 15.0586 10.0965 14.9186C9.33393 14.7785 8.61437 14.4631 7.99468 13.9971C7.37499 13.5312 6.87215 12.9275 6.52589 12.2338C6.17964 11.5401 5.99945 10.7753 5.99958 10V8.414L0.392578 2.808L1.80758 1.393L21.6066 21.193L20.1916 22.607L15.4246 17.839ZM18.3746 15.16L16.9316 13.718C17.4406 12.908 17.7876 11.988 17.9286 11H19.9446C19.7795 12.4967 19.2395 13.9275 18.3746 15.16ZM15.4646 12.251L6.68458 3.471C7.23947 2.52312 8.09103 1.78433 9.10773 1.36875C10.1244 0.953164 11.2497 0.883915 12.3096 1.1717C13.3696 1.45948 14.3053 2.08828 14.9723 2.96096C15.6392 3.83364 16.0002 4.90165 15.9996 6L16.0006 10C16.0017 10.7818 15.8188 11.553 15.4666 12.251H15.4646Z"
                fill="#ED434B"
            />
        </svg>
    );
};

export default Mute;
